import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import {
  GetPaymentStatusDto,
  ITransactionTypeResponse,
  PaymentStatus,
  ServiceCallResponse,
} from '@fantaz/shared/data-access/models';
import { Observable, catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService {
  constructor(private http: HttpClient) {}

  getTransactionTypes(): Observable<ITransactionTypeResponse> {
    return this.http.get<ITransactionTypeResponse>(
      `${environment.apiBaseUrl}/core-client/api/user/transactionTypes`,
    );
  }

  fetchPaymentStatus(
    args: GetPaymentStatusDto,
  ): Observable<ServiceCallResponse<PaymentStatus>> {
    return this.http
      .post<PaymentStatus>(
        `${environment.apiBaseUrl}/core-client/api/payment/status`,
        {
          MerchantSessionID: args.merchantSessionId,
        },
      )
      .pipe(
        map((res) => ({
          success: true,
          payload: res,
        })),
        catchError((err) =>
          of({
            success: false,
            error: {
              message: err.error.message,
              code: err.error.code,
              err,
            },
          }),
        ),
      );
  }
}
